/**
 * Pay Clarity Utility
 * Replaces vague salary text with honest, trust-focused labels.
 */

const VAGUE_PAY_TERMS = [
  'competitive',
  'competitive pay',
  'competitive salary',
  'competitive compensation',
  'doe',
  'depends on experience',
  'based on experience',
  'negotiable',
  'tbd',
  'to be discussed',
  'commensurate with experience',
  'commensurate',
  'market rate',
  'attractive package',
  'excellent benefits',
];

export function formatPayDisplay(salaryRange) {
  if (!salaryRange || salaryRange.trim() === '') {
    return { text: 'Compensation not provided', isDisclosed: false };
  }

  const normalized = salaryRange.trim().toLowerCase();

  // Check if it's a vague term
  if (VAGUE_PAY_TERMS.includes(normalized)) {
    return { text: 'Pay not listed', isDisclosed: false };
  }

  // Check for "experience" mentions that indicate undisclosed pay
  if (
    normalized.includes('based on experience') ||
    normalized.includes('depends on experience') ||
    normalized.includes('commensurate')
  ) {
    return { text: 'Pay based on experience (not disclosed)', isDisclosed: false };
  }

  // Check for "Varies by role" (common in job boards)
  if (normalized === 'varies by role' || normalized === 'varies') {
    return { text: 'Pay varies by role', isDisclosed: false };
  }

  // Has actual dollar amounts or clear pay info → show as-is
  return { text: salaryRange, isDisclosed: true };
}
